import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

export const rutaPropinas = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/jornada/propinas',
  component: lazyRouteComponent(
    () => import('../../funcionalidades/jornada-caja/PaginaPropinas.js'), 'PaginaPropinas'),
});
